import { ImportColumn } from 'components/common/importModal'
import Api from './axiosInstance'
import { API_IMPORT } from 'utils/constants'

export const getImportTemplate = (
  module: string,
): Promise<{ data: { columns: ImportColumn[] } }> =>
  Api.get({ url: API_IMPORT.TEMPLATE, params: { module } })

export const downloadImportSample = (module: string) =>
  Api.get({ url: API_IMPORT.SAMPLE, params: { module }, responseType: 'blob' })
